import { RootState } from '../root';

export const selectError = (state: RootState) => state.appVersion.error;
export const selectApplicationVersionHasUnsavedChanges = (state: RootState) =>
    state.appVersion.applicationVersionHasUnsavedChanges;
